import dayjs from 'dayjs'
import _ from 'lodash'
import API from '@/views/Fdc/Apis/'
import AlarmDescModal from './Components/AlarmDescModal.vue'
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'

export default {
  name: 'SpcAnalysis',
  components: {
    'alarm-desc-modal': AlarmDescModal
  },
  watch: {
    spcModelList: {
      deep: true,
      handler () {
        this.getParamAliasList()
      }
    }
  },
  mounted: function () {
    this.getSummaryTypeList()

    let now = dayjs()
    this.startDate = new Date(now.subtract('7', 'day'))
    this.endDate = new Date(now)
    this.startTime = new Date(now.subtract('7', 'day').hour('00').minute('00').second('00'))
    this.endTime = new Date(now.hour(`${new Date().getHours()}`).minute(`${new Date().getMinutes()}`).second('59'))
  },
  methods: {
    /**
     * 스플릿 패널 리사이즈 시 플라틀리 리사이즈
     * 윈도우 리사이즈 이벤트 생성해서 디스패치
     */
    splitPanesResized () {
      window.dispatchEvent(new Event('resize'))
    },
    // onChangeTab (index) {
    //   this.selectedTab = index
    // },
    // initAlarmListGrid (grid) {
    //   this.alarmListGrid = grid

    //   // grid 내 virtual data editor button set
    //   grid.formatItem.addHandler((s, e) => {
    //     if (e.panel === s.cells) {
    //       let col = s.columns[e.col]
    //       // let item = s.rows[e.row].dataItem
    //       switch (col.binding) {
    //         case 'alarm_msg':
    //           e.cell.className = e.cell.className + ' alarm-desc'
    //           break
    //       }
    //     }
    //   })

    //   // virtual data edit button event 설정
    //   grid.addEventListener(grid.hostElement, 'dblclick', (e) => {
    //     if (e.target.className.includes('alarm-desc')) {
    //       this.alarmDesc = e.target.innerText
    //       this.alarmDescModalVisible = true
    //     }
    //   })

    //   this.alarmList = []
    // },
    initMainChartDataGrid () {
      this.mainChartGridData = []
    },
    closeAlarmDescModal () {
      this.alarmDescModalVisible = false
      this.alarmDesc = null
    },
    async drawSubchart () {
      let names = []
      // 메인 차트, RANGE SELECTOR 차트 초기화
      this.tempMainChartSeriesData = [...this.tempMainChartSeriesData]
      this.rangeSelectorKey = this.rangeSelectorKey + 1
      // 서브 차트 데이터 LOAD
      if (Object.keys(this.tempSeriesData).length === 0 && this.tempSeriesData.constructor === Object) {
        let node = this.selectedTreeNode
        const lotStepYn = this.searchTarget === this.$t('fdc.SPC.LABEL.STEP') ? 'N' : 'Y'
        const paramName = this.paramAliasList.find(data => data.paramAlias === this.paramAlias).paramName
        let paramsParamList = []
        paramsParamList.push(paramName) // AR_FLOW

        let paramsStepList = []
        paramsStepList.push(this.stepId)
        let paramsSummaryTypeList = []
        this.extraSummaryTypeList.filter(extraSummaryType => extraSummaryType.checked).forEach(checkedSummaryType => {
          paramsSummaryTypeList.push(checkedSummaryType.smryType)
        })
        let paramsForSummaryData = {
          reqSummaryPK: [{
            fabId: node.detail.fab,
            eqpId: node.detail.eqpId,
            moduleId: node.detail.moduleId
          }],
          paramList: paramsParamList,
          stepList: paramsStepList,
          summaryTypeList: paramsSummaryTypeList,
          lotStepYn: lotStepYn,
          fromDate: dayjs(this.startDate).format('YYYY-MM-DD') + ' ' + dayjs(this.startTime).format('HH:mm:ss'),
          toDate: dayjs(this.endDate).format('YYYY-MM-DD') + ' ' + dayjs(this.endTime).format('HH:mm:ss'),
          searchKind: 'SmryAnalisys'
        }
        this.chartParamName = paramsParamList[0]
        await API.Analysis.getSpcSummaryDatas(paramsForSummaryData).then(
          res => {
            if (res.datas && res.paramNames) {
              this.smryData = res
              this.subChartSmryTypeList = this.extraSummaryTypeList.map(data => data.smryType)
              let tempSeriesData = {}
              this.subChartSmryTypeList.forEach(subChartSmryType => {
                const key = `${paramName}.${this.stepId}.${subChartSmryType}`
                names.push(key)
                tempSeriesData[subChartSmryType] = []
                res.datas.forEach((data, index) => {
                  const keys = Object.keys(data)
                  const paramAlias = this.getParamAlias(paramName)
                  const newKey = `${paramAlias}.${this.stepId}.${subChartSmryType}`
                  if (keys.includes(key)) {
                    const newData = {
                      Fab: this.selectedTreeNode.detail.fab,
                      [`Eqp Id`]: this.selectedTreeNode.detail.eqpId,
                      [`Module Id`]: this.selectedTreeNode.detail.moduleId,
                      [`Param Alias`]: this.paramAlias,
                      [`Recipe Id`]: this.recipe,
                      [`Step Id`]: this.stepId,
                      [`Smry Type`]: subChartSmryType,
                      [`Lot Id`]: data.lotId,
                      [`SubStrate Id`]: data.substId,
                      y: data[key],
                      x: new Date(data.endDt),
                      title: newKey
                    }
                    tempSeriesData[subChartSmryType].push(newData)
                  }
                })
              })
              this.tempSeriesData = tempSeriesData
            }
          }
        )
      } else {
        for (let key in this.tempSeriesData) {
          this.tempSeriesData[key] = [...this.tempSeriesData[key]]
        }
      }

      const drawableSubChartSmryTypeList = this.extraSummaryTypeList
        .filter(extraSummaryType => extraSummaryType.checked && this.subChartSmryTypeList.includes(extraSummaryType.smryType))
        .map(filteredExtraSummaryType => filteredExtraSummaryType.smryType)
      this.subChartNo = drawableSubChartSmryTypeList.length
      if (drawableSubChartSmryTypeList.length > 0) {
        this.hasSubChart = true
      } else {
        this.hasSubChart = false
      }
      this.drawableSubChartSmryTypeList = drawableSubChartSmryTypeList

      // let container = document.getElementById('sub-chart-container')
      // while (container.firstChild) {
      //   container.removeChild(container.firstChild)
      // }
      // TODO: component 생성 시점의 차이로 인한 setTimeout 적용..(임시) 다른 방법 찾아볼 것!
      setTimeout(() => {
        this.extraSummaryTypeList.filter(e => e.checked).forEach((e, index) => {
          let subChartId = 'sub-chart-' + e.smryType
          // let div = document.createElement('brique-chart')
          // div.id = subChartId
          // div.style.height = '100%'
          // container.append(div)
          let traces = [{
            name: `${this.paramAliasList.find(data => data.paramAlias === this.paramAlias).paramName}.${this.stepId}.${e.smryType}`,
            mode: 'markers',
            type: 'scattergl',
            x: this.tempSeriesData[e.smryType].map(e => e.x),
            y: this.tempSeriesData[e.smryType].map(e => e.y),
            hovertemplate: '%{y}'
          }]
          let layout = {
            showlegend: true,
            legend: {
              orientation: 'h',
              y: 1.2
            },
            xaxis: {
              tickformat: '%Y-%m-%d %H:%M:%S'
            },
            hovermode: 'x unified'
          }
          let config = {
            responsive: true,
            scrollZoom: true,
            displaylogo: false,
            displayModeBar: true
          }
          BriqueChart.newPlot(subChartId, traces, layout, config)
        })
        this.splitPanesResized()
      })
    },
    getParamAlias (paramName) {
      return this.paramAliasList.find(data => data.paramName === paramName).paramAlias
    },
    resetModel () {
      this.paramAliasList = []
      this.recipeList = []
      this.stepIdList = []
      this.summaryTypeList = []
      this.paramAlias = null
      this.recipe = null
      this.stepId = null
      this.summaryType = null
    },
    getParamAliasList () {
      if (this.spcModelList.length === 0) {
        this.resetModel()
        return
      }
      const lotStepYn = this.searchTarget === this.$t('fdc.SPC.LABEL.STEP') ? 'N' : 'Y'
      let paramAliasList = this.spcModelList
        .filter(spcModel => spcModel.lotStepYn === lotStepYn)
        .map(filteredSpcModel => filteredSpcModel.paramAlias)
        .reduce((datas, data) => datas.includes(data) ? datas : [...datas, data], [])
      this.paramAliasList = paramAliasList.map(paramAlias => ({
        paramAlias,
        paramName: this.spcModelList.find(spcModel => spcModel.paramAlias === paramAlias).paramName
      }))
      this.paramAlias = this.paramAliasList[0].paramAlias
      this.getRecipeList()
    },
    getRecipeList () {
      const lotStepYn = this.searchTarget === this.$t('fdc.SPC.LABEL.STEP') ? 'N' : 'Y'
      this.recipeList = this.spcModelList
        .filter(spcModel => spcModel.lotStepYn === lotStepYn)
        .filter(filteredSpcModel => filteredSpcModel.paramAlias === this.paramAlias)
        .map(compactData => compactData.recipeId)
        .reduce((datas, data) => datas.includes(data) ? datas : [...datas, data], [])
      this.recipe = this.recipeList[0]
      this.getStepIdList()
    },
    getStepIdList () {
      const lotStepYn = this.searchTarget === this.$t('fdc.SPC.LABEL.STEP') ? 'N' : 'Y'
      this.stepIdList = this.spcModelList
        .filter(spcModel => spcModel.lotStepYn === lotStepYn)
        .filter(filteredSpcModel => filteredSpcModel.paramAlias === this.paramAlias && filteredSpcModel.recipeId === this.recipe)
        .map(compactData => compactData.stepId)
        .reduce((datas, data) => datas.includes(data) ? datas : [...datas, data], [])
      this.stepId = this.stepIdList[0]
      this.getSummaryTypeList()
    },
    getSummaryTypeList () {
      const lotStepYn = this.searchTarget === this.$t('fdc.SPC.LABEL.STEP') ? 'N' : 'Y'
      this.summaryTypeList = this.spcModelList
        .filter(spcModel => spcModel.lotStepYn === lotStepYn)
        .filter(filteredSpcModel => filteredSpcModel.paramAlias === this.paramAlias && filteredSpcModel.recipeId === this.recipe && filteredSpcModel.stepId === this.stepId)
        .map(compactData => compactData.smryType)
        .reduce((datas, data) => datas.includes(data) ? datas : [...datas, data], [])
      this.summaryType = this.summaryTypeList[0]
    },
    eqpTreeSelected (node) {
      this.selectedTreeNode = node

      this.searchSpcModel()
    },
    getBasePayload () {
      return {
        fab: this.selectedTreeNode.detail.fab,
        eqpId: this.selectedTreeNode.detail.eqpId,
        moduleId: this.selectedTreeNode.detail.moduleId
      }
    },
    rangeChanged (flex) {
      this.flexMinMax = {
        min: flex.min,
        max: flex.max
      }
    },
    async searchSpcModel () {
      if (this.selectedTreeNode.length === 0 || !this.selectedTreeNode.detail.moduleId) {
        return
      }

      let node = this.selectedTreeNode
      this.searchTreeNode = this.selectedTreeNode
      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )

      const searchCondition = {
        fab: node.detail.fab,
        eqpId: node.detail.eqpId,
        moduleId: node.detail.moduleId,
        useYn: 'Y'
      }
      await API.Model.getSpcModels2(searchCondition).then(res => {
        this.spcModelList = res
      })
    },
    async search () {
      this.alarmList = []
      this.mainChartGridData = []
      this.hasSubChart = false
      if (this.selectedTreeNode.length === 0 || !this.selectedTreeNode.detail.moduleId) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Module ID']))
        return
      }

      this.tempSeriesData = {} // 서브 차트 데이터 초기화
      this.drawableSubChartSmryTypeList = []
      this.tempMainChartSeriesData = [] // 메인 차트 데이터 초기화
      // 차트 axisX 초기화
      this.flexMinMax = null

      // search condition - alarm 테이블
      let node = this.selectedTreeNode
      this.searchTreeNode = this.selectedTreeNode

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )

      // 메인 차트
      const startDate = dayjs(this.startDate).format('YYYY-MM-DD') + ' ' + dayjs(this.startTime).format('HH:mm:ss')
      const endDate = dayjs(this.endDate).format('YYYY-MM-DD') + ' ' + dayjs(this.endTime).format('HH:mm:ss')
      const lotStepYn = this.searchTarget === this.$t('fdc.SPC.LABEL.STEP') ? 'N' : 'Y'
      const paramName = this.paramAliasList.find(data => data.paramAlias === this.paramAlias).paramName

      const searchCondition = {
        fab: node.detail.fab,
        eqpId: node.detail.eqpId,
        moduleId: node.detail.moduleId,
        paramName: paramName,
        recipeId: this.recipe,
        stepId: this.stepId,
        smryType: this.summaryType,
        startDt: startDate,
        endDt: endDate // smry_data의 end_dt
      }

      this.chartStepId = this.stepId
      this.chartSmryType = this.summaryType
      this.chartParamAliasName = this.paramAlias
      const newKey = `${this.paramAlias}.${this.stepId}.${this.summaryType}`

      let mainChartData = []
      let mainChartGridData = []
      await API.Analysis.getSpcDatas(searchCondition).then(res => {
        res.forEach(data => {
          let tempData = {
            Fab: this.selectedTreeNode.detail.fab,
            [`Eqp Id`]: this.selectedTreeNode.detail.eqpId,
            [`Module Id`]: this.selectedTreeNode.detail.moduleId,
            [`Param Alias`]: this.paramAlias,
            [`Recipe Id`]: this.recipe,
            [`Step Id`]: this.stepId,
            [`Smry Type`]: this.summaryType,
            [`Lot Id`]: data.lotId,
            [`lot`]: data.lotId,
            [`SubStrate Id`]: data.substId,
            [`SubstrateId`]: data.substId,
            [`Sigma Estimate`]: data.sigmaEstimate,
            USL: data.uslVal,
            UCL: data.uclVal,
            CL: data.clVal,
            LCL: data.lclVal,
            LSL: data.lslVal,
            [`Date Time`]: new Date(data.endDt),
            P2SIGMA: data.clVal + (2 * data.sigmaEstimate),
            P1SIGMA: data.clVal + (1 * data.sigmaEstimate),
            M1SIGMA: data.clVal - (1 * data.sigmaEstimate),
            M2SIGMA: data.clVal - (2 * data.sigmaEstimate)
          }
          if (!_.isEmpty(data.faultRuleList) && data.faultRuleList.length > 0) tempData['Fault Rule List'] = JSON.parse(data.faultRuleList)
          tempData['FaultRuleList'] = (!_.isEmpty(data.faultRuleList) && data.faultRuleList.length > 0) ? JSON.parse(data.faultRuleList) : ''
          let chartData = Object.assign({
            [newKey]: data.paramVal
          }, tempData)
          let gridData = Object.assign({
            Value: data.paramVal
          }, tempData)
          mainChartData.push(chartData)
          mainChartGridData.push(gridData)
        })

        this.tempMainChartSeriesData = mainChartData
        // this.mainChartGridData = mainChartGridData
        this.mainChartGridData = this.formatGridData(mainChartGridData)

        let traces = [
          {
            name: newKey,
            mode: 'markers',
            type: 'scattergl',
            x: res.filter(element => element.faultRuleList === '[]').map(element => dayjs(element.endDt).toDate()),
            y: res.filter(element => element.faultRuleList === '[]').map(element => element.paramVal),
            text: this.tempMainChartSeriesData,
            hovertemplate: '%{x}<br><b>Lot ID:</b> %{text.lot}<br><b>Substrate ID:</b> %{text.SubstrateId}'
          }, {
            name: 'Fault',
            mode: 'markers',
            type: 'scattergl',
            x: res.filter(element => element.faultRuleList !== '[]').map(element => dayjs(element.endDt).toDate()),
            y: res.filter(element => element.faultRuleList !== '[]').map(element => element.paramVal),
            marker: { color: 'rgba(227, 65, 96, .8)' },
            text: this.tempMainChartSeriesData,
            hovertemplate: '%{x}<br><b>Lot ID:</b> %{text.lot}<br><b>Substrate ID:</b> %{text.SubstrateId}<br><b>Fault Rule List:</b> %{text.FaultRuleList}',
            showlegend: false
          }, {
            name: 'CL',
            mode: 'lines',
            x: res.map(element => dayjs(element.endDt).toDate()),
            y: res.map(element => element.clVal),
            line: { color: 'rgba(81, 109, 136, .8)' },
            showlegend: false
          }, {
            name: 'UCL',
            mode: 'lines',
            x: res.map(element => dayjs(element.endDt).toDate()),
            y: res.map(element => element.uclVal),
            line: { color: 'rgba(236, 126, 48, .8)' },
            showlegend: false
          }, {
            name: 'LCL',
            mode: 'lines',
            x: res.map(element => dayjs(element.endDt).toDate()),
            y: res.map(element => element.lclVal),
            line: { color: 'rgba(236, 126, 48, .8)' },
            showlegend: false
          }, {
            name: 'USL',
            mode: 'lines',
            x: res.map(element => dayjs(element.endDt).toDate()),
            y: res.map(element => element.uslVal),
            line: { color: 'rgba(227, 65, 96, .8)' },
            showlegend: false
          }, {
            name: 'LSL',
            mode: 'lines',
            x: res.map(element => dayjs(element.endDt).toDate()),
            y: res.map(element => element.lslVal),
            line: { color: 'rgba(227, 65, 96, .8)' },
            showlegend: false
          }, {
            name: 'P2SIGMA',
            mode: 'lines',
            x: res.map(element => dayjs(element.endDt).toDate()),
            y: res.map(element => element.clVal + (2 * element.sigmaEstimate)),
            line: { color: 'rgba(189, 65, 227, .8)' },
            showlegend: false
          }, {
            name: 'M2SIGMA',
            mode: 'lines',
            x: res.map(element => dayjs(element.endDt).toDate()),
            y: res.map(element => element.clVal - (2 * element.sigmaEstimate)),
            line: { color: 'rgba(189, 65, 227, .8)' },
            showlegend: false
          }, {
            name: 'P1SIGMA',
            mode: 'lines',
            x: res.map(element => dayjs(element.endDt).toDate()),
            y: res.map(element => element.clVal + (1 * element.sigmaEstimate)),
            line: { color: 'rgba(26, 168, 121, .8)' },
            showlegend: false
          }, {
            name: 'M1SIGMA',
            mode: 'lines',
            x: res.map(element => dayjs(element.endDt).toDate()),
            y: res.map(element => element.clVal - (1 * element.sigmaEstimate)),
            line: { color: 'rgba(26, 168, 121, .8)' },
            showlegend: false
          }
        ]
        let layout = {
          legend: {
            orientation: 'h',
            y: 1.2
          },
          xaxis: {
            tickformat: '%Y-%m-%d %H:%M:%S'
          },
          hovermode: 'x unified'
        }
        let config = {
          responsive: true,
          scrollZoom: true,
          displaylogo: false,
          displayModeBar: true
        }
        let p1 = BriqueChart.newPlot('mainChart1', traces, layout, config)
        let p2 = BriqueChart.newPlot('mainChart2', traces, layout, config)

        Promise.all([p1, p2]).then(() => {
          document.querySelector(`#mainChart2`).on('plotly_relayout', event => {
            if (event.recursive) return
            if (event['xaxis.range[0]'] || event['xaxis.autorange'] || event['autosize'] || event['xaxis.range']) {
              let container = document.querySelector('#sub-chart-container')
              let mainLayout = document.querySelector(`#mainChart2`).layout
              for (let i = 0; i < container.children.length; i++) {
                BriqueChart.relayout(container.children[i].id, {
                  'xaxis.range[0]': mainLayout.xaxis.range[0],
                  'xaxis.range[1]': mainLayout.xaxis.range[1],
                  recursive: true
                })
              }
            }
          })

          BriqueChart.restyle(document.getElementById('mainChart1'), { 'visible': this.showSigmaLine }, [7, 8, 9, 10])
          BriqueChart.restyle(document.getElementById('mainChart2'), { 'visible': this.showSigmaLine }, [7, 8, 9, 10])
          this.splitPanesResized()
        })
      })
      const paramsForExtraSummaryTypeList = {
        fab: node.detail.fab,
        eqpId: node.detail.eqpId,
        moduleId: node.detail.moduleId,
        recipeId: this.recipe, // smry_data의 end_dt
        stepId: this.stepId,
        paramName: paramName,
        smryType: this.summaryType,
        lotStepYn: lotStepYn
      }
      this.extraSummaryTypeList = await API.Model.getSpcExtraSummaryTypes(paramsForExtraSummaryTypeList)

      // Fault Alarm 그리드 데이터
      const payload = {
        fab: node.detail.fab,
        eqpId: node.detail.eqpId,
        moduleId: node.detail.moduleId,
        paramName: paramName,
        recipeId: this.recipe,
        stepId: this.stepId,
        smryType: this.summaryType,
        lotStepYn: lotStepYn,
        startDt: startDate,
        endDt: endDate
      }
      this.payloadForGridRefresh = payload
      await API.Analysis.getFaultAlarmDatas(payload).then(res => {
        this.alarmList = res.map(data => {
          const copyData = Object.assign({}, data)
          copyData.alarm_val = copyData.alarm_val + ''
          copyData.alarm_dt = dayjs(data.alarm_dt).format('YYYY-MM-DD HH:mm:ss')
          return copyData
        })
      })
    },
    async refreshGrid () {
      this.alarmList = []
      await API.Analysis.getFaultAlarmDatas(this.payloadForGridRefresh).then(res => {
        this.alarmList = res.map(data => {
          const copyData = Object.assign({}, data)
          copyData.alarm_val = copyData.alarm_val + ''
          copyData.alarm_dt = dayjs(data.alarm_dt).format('YYYY-MM-DD HH:mm:ss')
          return copyData
        })
      })
    },
    async resetChartZoom () {
      // 차트 줌 리셋
      this.tempMainChartSeriesData = [...this.tempMainChartSeriesData]
      this.rangeSelectorKey = this.rangeSelectorKey + 1
      for (let key in this.tempSeriesData) {
        this.tempSeriesData[key] = [...this.tempSeriesData[key]]
      }
    },
    exportFaultListCSV () {
      // this.$refs.alarmListGrid.exportExcel('Fault Alarm Data')
      this.$refs.alarmListGrid.gridApi.exportDataAsCsv({
        fileName: 'Fault Alarm Data.csv'
      })
    },
    exportMainChartCSV () {
      // this.$refs.mainChartDataGrid.exportExcel('Main Chart Data')
      this.$refs.mainChartDataGrid.gridApi.exportDataAsCsv({
        fileName: 'Main Chart Data.csv'
      })
    },
    onClickCheckbox () {
      BriqueChart.restyle(document.getElementById('mainChart1'), { 'visible': this.showSigmaLine }, [7, 8, 9, 10])
      BriqueChart.restyle(document.getElementById('mainChart2'), { 'visible': this.showSigmaLine }, [7, 8, 9, 10])
    },
    formatGridData (chartData) {
      let data = [ ...chartData ]

      data.forEach(row => {
        row['Date Time'] = dayjs(row['Date Time']).format('YYYY-MM-DD HH:mm:ss')
      })

      return data
    },
    /**
     * BRIQUE Grid cell double click event
     * @param {*} event event
     */
    onCellDoubleClick (event) {
      if (event.column.colId === 'alarmMsg') {
        this.alarmDesc = event.data.alarmMsg
        this.alarmDescModalVisible = true
      }
    }
  },
  data () {
    return {
      hasSubChart: false,
      selectedTreeNode: [],
      searchTreeNode: [],

      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true,
        editable: false
      }, // BRIQUE Grid column default setting

      alarmListGridColumns: [
        // { label: this.$t('fdc.COMMON.COLUMN.FAB'), binding: 'fab', width: 100, required: true, modifiable: false, visible: false },
        // { label: this.$t('fdc.COMMON.COLUMN.EQP_ID'), binding: 'eqpId', width: 100, required: true, modifiable: false, visible: false },
        // { label: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), binding: 'moduleId', width: 100, required: true, modifiable: false, visible: false },
        // { label: this.$t('fdc.SPC.COLUMN.PARAM_ALIAS'), binding: 'paramAlias', width: 120, required: true, modifiable: false, visible: false },
        // { label: this.$t('fdc.COMMON.COLUMN.RECIPE'), binding: 'recipeId', width: 80, required: true, modifiable: false, visible: false },
        // { label: this.$t('fdc.COMMON.COLUMN.STEP'), binding: 'stepId', width: 70, required: true, modifiable: false, visible: false },
        // { label: this.$t('fdc.COMMON.COLUMN.SUMMARY_TYPE'), binding: 'smryType', width: 120, required: true, modifiable: false, visible: false },
        // { label: this.$t('fdc.COMMON.COLUMN.ALARM_TIME'), binding: 'alarmDt', width: 150, modifiable: false },
        // { label: this.$t('fdc.COMMON.COLUMN.RULE_NO'), binding: 'ruleNo', width: 100, modifiable: false },
        // { label: this.$t('fdc.COMMON.COLUMN.LOT_ID'), binding: 'lotId', width: 210, modifiable: false },
        // { label: this.$t('fdc.COMMON.COLUMN.SUBSTRATE_ID'), binding: 'substIdd', width: 150, modifiable: false },
        // { label: this.$t('fdc.COMMON.COLUMN.ALARM_VALUE'), binding: 'alarmVal', width: 150, modifiable: false },
        // { label: this.$t('fdc.COMMON.COLUMN.RULE_DESC'), binding: 'ruleDesc', width: 350, modifiable: false },
        // { label: this.$t('fdc.COMMON.COLUMN.ALARM_DESC'), binding: 'alarmMsg', width: 700, modifiable: false }

        { headerName: this.$t('fdc.COMMON.COLUMN.FAB'), field: 'fab', width: 100, required: true, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', width: 100, required: true, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', width: 100, required: true, hide: true },
        { headerName: this.$t('fdc.SPC.COLUMN.PARAM_ALIAS'), field: 'paramAlias', width: 120, required: true, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', width: 80, required: true, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.STEP'), field: 'stepId', width: 70, required: true, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.SUMMARY_TYPE'), field: 'smryType', width: 120, required: true, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALARM_TIME'), field: 'alarmDt', width: 150 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RULE_NO'), field: 'ruleNo', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.LOT_ID'), field: 'lotId', width: 210 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SUBSTRATE_ID'), field: 'substId', width: 150 },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALARM_VALUE'), field: 'alarmVal', width: 150 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RULE_DESC'), field: 'ruleDesc', width: 350 },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALARM_DESC'), field: 'alarmMsg', width: 700 }
      ],
      alarmList: [],

      searchTarget: this.$t('fdc.SPC.LABEL.STEP'),
      paramAlias: null,
      summaryType: null,
      recipe: null,
      stepId: null,
      paramAliasList: [],
      summaryTypeList: [],
      recipeList: [],
      stepIdList: [],
      spcModelList: [],
      mainChartDataGridColumns: [
        { headerName: this.$t('fdc.SPC.COLUMN.DATE_TIME'), field: 'Date Time', width: 120, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.FAB'), field: 'Fab', width: 100, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'Eqp Id', width: 100, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'Module Id', width: 100, hide: true },
        { headerName: this.$t('fdc.SPC.COLUMN.PARAM_ALIAS'), field: 'Param Alias', width: 120, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'Recipe Id', width: 80, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.STEP'), field: 'Step Id', width: 70, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.SUMMARY_TYPE'), field: 'Smry Type', width: 120, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.LOT_ID'), field: 'Lot Id', width: 210, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.SUBSTRATE_ID'), field: 'SubStrate Id', width: 150, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.USL'), field: 'USL', width: 80, type: 'numericColumn', valueFormatter: data => data.value.toFixed(4) },
        { headerName: this.$t('fdc.COMMON.COLUMN.UCL'), field: 'UCL', width: 80, type: 'numericColumn', valueFormatter: data => data.value.toFixed(4) },
        { headerName: this.$t('fdc.SPC.COLUMN.CL_VAL'), field: 'CL', width: 80, type: 'numericColumn', valueFormatter: data => data.value.toFixed(4) },
        { headerName: this.$t('fdc.COMMON.COLUMN.LCL'), field: 'LCL', width: 80, type: 'numericColumn', valueFormatter: data => data.value.toFixed(4) },
        { headerName: this.$t('fdc.COMMON.COLUMN.LSL'), field: 'LSL', width: 80, type: 'numericColumn', valueFormatter: data => data.value.toFixed(4) },
        { headerName: this.$t('fdc.SPC.COLUMN.P2SIGMA'), field: 'P2SIGMA', width: 100, type: 'numericColumn', valueFormatter: data => data.value.toFixed(4) },
        { headerName: this.$t('fdc.SPC.COLUMN.P1SIGMA'), field: 'P1SIGMA', width: 100, type: 'numericColumn', valueFormatter: data => data.value.toFixed(4) },
        { headerName: this.$t('fdc.SPC.COLUMN.M1SIGMA'), field: 'M1SIGMA', width: 100, type: 'numericColumn', valueFormatter: data => data.value.toFixed(4) },
        { headerName: this.$t('fdc.SPC.COLUMN.M2SIGMA'), field: 'M2SIGMA', width: 100, type: 'numericColumn', valueFormatter: data => data.value.toFixed(4) },
        { headerName: this.$t('fdc.SPC.COLUMN.SIGMA_ESTIMATE'), field: 'Sigma Estimate', width: 100, type: 'numericColumn', valueFormatter: data => data.value.toFixed(4) },
        { headerName: this.$t('fdc.SPC.COLUMN.VALUE'), field: 'Value', width: 150, type: 'numericColumn', valueFormatter: data => data.value.toFixed(10) },
        { headerName: this.$t('fdc.SPC.COLUMN.FAULT_RULE_LIST'), field: 'Fault Rule List', width: 200 }
      ],
      mainChartGridData: [],

      startDate: null,
      endDate: null,
      startTime: null,
      endTime: null,

      extraSummaryTypeList: [],
      subChartSmryTypeList: [],
      drawableSubChartSmryTypeList: [],
      subChartNo: 0,

      smryData: {},
      tempSeriesData: {},
      tempMainChartSeriesData: [],
      chartParamName: null,
      chartParamAliasName: null,
      chartStepId: null,
      chartSmryType: null,

      flexMinMax: null,

      // 모달 용
      alarmDesc: null,
      modalTitle: '',
      alarmDescModalVisible: false,

      showSigmaLine: false,
      payloadForGridRefresh: null,
      rangeSelectorKey: 0
      // selectedTab: 0
    }
  }
}
